module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/client_one-3003768c85ce81d7120965cb806c0ad0.png";